import React from "react";
import { connect } from "react-redux";
import { retrieveAndUpdateUserInformation, signIn, signOut } from "../../actions";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./GoogleAuth.css";
import monkeyServerAxios from "../../common-util/monkeyServerAxios";

class GoogleAuth extends React.Component {
  componentDidMount(){
    // setup google OAuth
    window.gapi.load("client:auth2", ()=>{
      window.gapi.client.init({
        clientId: "282779775924-6e7c1accpk1ulph69bu2ndrivjk7u42v.apps.googleusercontent.com",
        scope: "email"
      }).then(()=>{
        this.auth = window.gapi.auth2.getAuthInstance();
        this.onAuthChange(this.auth.isSignedIn.get());
        this.auth.isSignedIn.listen(this.onAuthChange);
      });
    });

    // awake monkey server, do not do anything else
    monkeyServerAxios.get()
    .then(res => {
      console.log(res.status, res.data);
    })
    .catch(err => {
      console.log(err.message);
    });
  }

  onAuthChange = (isSignedIn) => {
    if(isSignedIn) {
      // record user information into redux store
      const userId = this.auth.currentUser.get().getId();
      const idToken = this.auth.currentUser.get().getAuthResponse().id_token;
      const tokenSource = "google";
      this.props.signIn(
        {
          userId: userId,
          userName: this.auth.currentUser.get().getBasicProfile().getName(),
          userGivenName: this.auth.currentUser.get().getBasicProfile().getGivenName(),
          source: tokenSource
        }
      );

      // update user information once retrieved from the database
      this.props.retrieveAndUpdateUserInformation(userId, idToken, tokenSource);

    } else {
      this.props.signOut();
    }
  }

  onSignInClick = () =>{
    this.auth.signIn();
  }

  onSignOutClick = () =>{
    this.auth.signOut();
  }

  renderAuthButton () {
    if(this.props.isSignedIn === null) {
      return null;
    } else if (this.props.isSignedIn) {
      return (
        <Button onClick={this.onSignOutClick} className="button" variant="outline-success">
          <FormattedMessage
            id="header.signOut"
            defaultMessage="Sign out"
          />
        </Button>
      );
    } else {
      return (
        <Button onClick={this.onSignInClick} className="button" variant="outline-success">
          <i className="fab fa-google"></i>
          &nbsp;&nbsp;
          <FormattedMessage
            id="header.signIn"
            defaultMessage="Sign in"
          />
        </Button>
      );
    }
  }

  render () {
    return <div>{this.renderAuthButton()}</div>
  }
}

const mapStateToProps = (state) => {
  return { 
    isSignedIn: state.user.isSignedIn,
    userId : state.user.userId
  };
}

export default connect(mapStateToProps, { retrieveAndUpdateUserInformation, signIn, signOut })(GoogleAuth);